var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['loading-wrap',`position-${_vm.position}`]},[_c('div',{staticClass:"loading-imgWrap"},[_vm._m(0),_c('p',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-img"},[_c('img',{attrs:{"src":require("@/common/images/student/ic_upload_loading.png"),"alt":""}})])
}]

export { render, staticRenderFns }